/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import { getDataSource } from 'legacy/store/appReducer'
import { DATASOURCES } from 'legacy/constants'
import _ from 'lodash';

// Replacement for CustomDatePickerComponent
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

// import constants
import {
    STUDY_SERVICE_TYPE,
    DEVICE_SERVICE_TYPE_MCT,
    DEVICE_SERVICE_TYPE_EVENT,
    DEVICE_SERVICE_TYPE_HOLTER_EXT_HOLTER,
    STUDY_DURATION_DAY_EVENT_MCT,
    STUDY_DURATION_DAY_HOLTER,
    STUDY_DURATION_DAY_EXT_HOLTER,
    HOOK_UP_TYPE,
} from '../../constsnts/patientEnrollmentConstants';

// import custom components
import CustomTextField from '../Common/FormMUIWrapperComponents/CustomTextField';
import CustomMultiSelect from '../Common/FormMUIWrapperComponents/CustomMultiSelectComboBox';
import CustomSingleSelect from '../Common/FormMUIWrapperComponents/CustomSingleSelect';
import CustomSingleSelectComboBox from '../Common/FormMUIWrapperComponents/CustomSingleSelectComboBox';

// import constants
import { TEXT_FIELD_CONST } from '../Common/FormMUIWrapperComponents/CustomTextField/Constants';
import { SELECT_FIELD_CONST } from '../Common/FormMUIWrapperComponents/CustomSingleSelect/Constants';
import { DATE_TIME_PICKER_CONST } from '../Common/FormMUIWrapperComponents/CustomDateTimePicker/Constants';

// Import styles
import styles from "./StudyEnrollmentForm.styles.module.css";
import CommonStyles from '../Common/CommonStyles.css';

const StudyEnrollmentForm = props => {
    const state = useSelector(state => state)
    const enrolledStudyData = useSelector(state => state.idtfPatientEnrollment.patientEnrollment && state.idtfPatientEnrollment.patientEnrollment.enrolledOverviewData && state.idtfPatientEnrollment.patientEnrollment.enrolledOverviewData.latest_enrollment)
    const enrolledPatientData = useSelector(state => state.idtfPatientEnrollment.patientEnrollment && state.idtfPatientEnrollment.patientEnrollment.enrolledPatientData);
    const [formData, setFormData] = useState({
        serviceType: {}, // Dropdown combobox
        device: {}, // Dropdown combobox
        studyDurationInDays: {}, // Dropdown combobox
        enrollmentDate: new Date(), // Date
        deviceSerialNumber: '',
        hookupType: {}, // Dropdown combobox
        icd10Codes: [],
        // icd10Codes: enrolledPatientData && enrolledPatientData.enrollments && enrolledPatientData.enrollments[0].icd10Codes ? ICD10_CODE && ICD10_CODE.map((item) => enrolledPatientData.enrollments[0].icd10Codes.find((i)=> {if(i.id ==  item.id) {return i}})) : [], // Dropdown combobox
    });

    // initial validation is false, so set error as true
    const [formErrorState, setFormErrorState] = useState(true)
    const [ICD10_CODE, setICD10_CODE] = useState([])

    const {
        me,
        formNameSpace,
        validateMainForm,
    } = props

    // handle for the study duration based on service type selected
    const handleMenuForStudyDuration = () => {
        if (formData.serviceType && formData.serviceType.value === 'event') {
            return STUDY_DURATION_DAY_EVENT_MCT
        } else if (formData.serviceType && formData.serviceType.value === 'mct') {
            return STUDY_DURATION_DAY_EVENT_MCT
        } else if (formData.serviceType && formData.serviceType.value === 'holter') {
            return STUDY_DURATION_DAY_HOLTER
        } else if (formData.serviceType && formData.serviceType.value === 'extHolter') {
            return STUDY_DURATION_DAY_EXT_HOLTER
        }
    }

    // handle for the device type based on service type selected
    const handleMenuForDeviceType = () => {
        if (formData.serviceType && formData.serviceType.value === 'event') {
            return DEVICE_SERVICE_TYPE_EVENT
        } else if (formData.serviceType && formData.serviceType.value === 'mct') {
            return DEVICE_SERVICE_TYPE_MCT
        } else if (formData.serviceType && formData.serviceType.value === 'holter') {
            return DEVICE_SERVICE_TYPE_HOLTER_EXT_HOLTER
        } else if (formData.serviceType && formData.serviceType.value === 'extHolter') {
            return DEVICE_SERVICE_TYPE_HOLTER_EXT_HOLTER
        }
    }
    // update text field data to state
    const handleFormDataUpdate = (e, stateKey, val) => {
        let value = '';
        if (e && e.target) {
            value = e.target.value
        }
        if (stateKey) {
            const tempFormData = { ...formData };
            switch (stateKey) {
                case 'serviceType':
                    tempFormData.serviceType = val
                    tempFormData['device'] = {}
                    tempFormData['studyDurationInDays'] = {}
                    // let selectedST = STUDY_SERVICE_TYPE.find(o => o.value === value);
                    // if (selectedST) {
                    //     tempFormData[stateKey] = selectedST;
                    //     tempFormData['device'] = {}
                    //     tempFormData['studyDurationInDays'] = {}
                    // }
                    break;
                case 'device':
                    // let selectedD = DEVICE.find(o => o.value === value);
                    if (val) {
                        tempFormData[stateKey] = val;
                    }
                    break;
                case 'studyDurationInDays':
                    // let selectedSDD = handleMenuForStudyDuration().find(o => o.value === value);
                    if (val) {
                        tempFormData[stateKey] = val;
                    }
                    break;
                case 'enrollmentDate':
                    if (e) {
                        tempFormData[stateKey] = new Date(e);
                    }
                    break;
                case 'deviceSerialNumber':
                    tempFormData[stateKey] = value;
                    break;
                case 'hookupType':
                    // let selectedHT = HOOK_UP_TYPE.find(o => o.value === value);
                    if (val) {
                        tempFormData[stateKey] = val;
                    }
                    break;
                case 'icd10Codes':
                    if (val) {
                        tempFormData[stateKey] = val;
                    }
                    break;
                default:
                    break;
            }
            setFormData(tempFormData)
        }
    }

    const handleDateChange = (date) => {
        const tempFormData = { ...formData };
        tempFormData["enrollmentDate"] = date;
        setFormData(tempFormData)
    }

    useEffect(() => {
        // if form data is updated, pass the updated data to Parent form with error state
        validateMainForm(formNameSpace, formErrorState, formData);
    }, [formData])
  
    useEffect(() => {
        if (me.data && me.data.teams) {
            const icd10 = getDataSource(state, DATASOURCES.ICD10_CODES)
            if (icd10 && !icd10.isFetching) {
                setICD10_CODE(Object.values(icd10.data.byId))
                // setFormData({
                //     ...formData,
                //     icd10Codes: enrolledPatientData && enrolledPatientData.enrollments && enrolledPatientData.enrollments[0].icd10Codes.map((item)=> item)
                //     // icd10Codes: enrolledPatientData && enrolledPatientData.enrollments && enrolledPatientData.enrollments[0].icd10Codes ? icd10 && icd10.data.byId.map((item) => item.byId[enrolledPatientData.enrollments[0].icd10Codes.map((i)=> {{return i.id}})] ) : [], // Dropdown combobox
                // })
                // setICD10_CODE(Object.keys(icd10.data.byId).map(icd => { return {'value' : icd10.data.byId[icd].id , 'label': `${icd10.data.byId[icd].id} - ${icd10.data.byId[icd].name}`}}))
            }
        }
    }, [me.isFetching])

    // on change of errorState of form
    useEffect(() => {
        validateMainForm(formNameSpace, formErrorState, formData);
    }, [formErrorState])


    // validate Form state
    const validateForm = (state) => {
        // if state true, means error, so update state
        if (state) {
            setFormErrorState(state)
        } else {
            // check service type is 'event' and device is 'KM6L'
            if (formData.serviceType.value === 'event' && formData.device.value === 'KM6L') {
                // check if all required field is filled
                if (!_.isEmpty(formData.serviceType) && !_.isEmpty(formData.device) && !_.isEmpty(formData.studyDurationInDays) && !_.isEmpty(formData.hookupType)
                    && (!_.isEmpty(formData.enrollmentDate) || formData.enrollmentDate !== '') && !_.isEmpty(formData.icd10Codes)) {
                    const formDataTemp = { ...formData };
                    formDataTemp.deviceSerialNumber = ''
                    setFormData(formDataTemp)
                    setFormErrorState(false)
                }
            } else {
                // check if all required field is filled
                // when hookupType is not 'home hookup', deviceSerialNumber is not mandatory
                if (!_.isEmpty(formData.serviceType) && !_.isEmpty(formData.device) && !_.isEmpty(formData.studyDurationInDays) && !_.isEmpty(formData.hookupType)
                    && (!_.isEmpty(formData.enrollmentDate) || formData.enrollmentDate !== '') && !_.isEmpty(formData.icd10Codes)
                    && formData.hookupType.value === 'home hookup') {
                        setFormErrorState(false)
                } else if (!_.isEmpty(formData.serviceType) && !_.isEmpty(formData.device) && !_.isEmpty(formData.studyDurationInDays) && !_.isEmpty(formData.hookupType)
                && (!_.isEmpty(formData.enrollmentDate) || formData.enrollmentDate !== '') && !_.isEmpty(formData.icd10Codes)
                && formData.hookupType.value !== 'home hookup' && formData.deviceSerialNumber !== '') {
                    setFormErrorState(false)
            } 
            }
        }
    }

    return (
        <div className={styles.pageContainer}>
            <h1 className={styles.title}>Study Enrollment</h1>
            <Grid container spacing={2}>
                {/* ============= Start of Grid ============= */}
                {/* Basic Details section */}
                <Grid item xs={4}>
                    <CustomSingleSelectComboBox
                        label="Service Type"
                        placeholder='Select Service Type'
                        variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                        menuItems={STUDY_SERVICE_TYPE}
                        valueKey='value'
                        // labelKey='label'
                        labelKeys={['label']}
                        // labelKeys={['label', 'lab',]}
                        // labelDisplayPrefix='Dr.'
                        // labelDisplaySeparator=' - '
                        stateKey='serviceType'
                        selectedValue={formData.serviceType}
                        handleChange={handleFormDataUpdate}
                        mandatory={true}
                        validateForm={validateForm}

                    />
                    {/* <CustomSingleSelectComboBox
                        label="Patient State"
                        placeholder='Select State'
                        variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                        menuItems={STATE_LIST}
                        mandatory={true}
                        valueKey='code'
                        labelKeys={['name', 'code']}
                        labelDisplaySeparator=' -'
                        // labelDisplayPrefix='Dr.'
                        // labelDisplaySeparator=' == '
                        stateKey='patientAddressState'
                        selectedValue={formData.patientAddressState}
                        validateForm={validateForm}
                        handleChange={handleFormDataUpdate}
                    /> */}
                </Grid>
                <Grid item xs={4}>
                    <CustomSingleSelectComboBox
                        label="Device"
                        placeholder='Select Device'
                        variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                        menuItems={handleMenuForDeviceType()}
                        mandatory={true}
                        valueKey='value'
                        labelKey='label'
                        labelKeys={['label']}
                        stateKey='device'
                        selectedValue={formData.device}
                        validateForm={validateForm}
                        handleChange={handleFormDataUpdate}
                    />
                </Grid>
                <Grid item xs={4}>
                    {/* <CustomDateTimePicker
                        label='Enrollment Date'
                        variant={DATE_TIME_PICKER_CONST.VARIANT.DATE}
                        value={formData.enrollmentDate}
                        inputFormat='MM-DD-YYYY'
                        mandatory={true}
                        stateKey='enrollmentDate'
                        validateForm={validateForm}
                        handleChange={handleFormDataUpdate}
                    /> */}
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <InputLabel shrink >
                            <label className={styles.label}>
                            Enrollment Date
                            </label>
                            <label className={CommonStyles.asterisk}>&#x2a;
                            </label>
                        </InputLabel>
                        <KeyboardDatePicker
                            style={{ marginTop: '8px' }}
                            disableToolbar
                            variant="inline"
                            size="small"
                            inputVariant="outlined"
                            format="MM-dd-yyyy"
                            placeholder="MM-DD-YYYY"
                            margin="normal"
                            id="enrollmentDate"
                            value={formData.enrollmentDate}
                            onChange={handleDateChange}
                            maxDate={moment().add(7, 'days')}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            fullWidth
                            disablePast
                            autoOk
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={4}>
                    <CustomSingleSelectComboBox
                        label="Study Duration (Days)"
                        placeholder='Select duration'
                        variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                        mandatory={true}
                        menuItems={handleMenuForStudyDuration()}
                        valueKey='value'
                        labelKey='label'
                        labelKeys={['label']}
                        stateKey='studyDurationInDays'
                        selectedValue={formData.studyDurationInDays}
                        handleChange={handleFormDataUpdate}
                        validateForm={validateForm}
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomSingleSelectComboBox
                        label="Hook-up Type"
                        placeholder='Select Hook-up type'
                        variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                        menuItems={HOOK_UP_TYPE}
                        valueKey='value'
                        labelKey='label'
                        labelKeys={['label']}
                        stateKey='hookupType'
                        selectedValue={formData.hookupType}
                        handleChange={handleFormDataUpdate}
                        mandatory={true}
                        validateForm={validateForm}
                    />
                </Grid>
                <Grid item xs={4}>
                    {/* when serviceType is selected & serviceType == event, hide the  */}
                    {/* Do not show any Serial Number field  */}
                    {/* when serviceType is not event(Holter) and device is not KM6L (Kardia patch) & hookupType is home hookup show deviceSerialNumber with not mandatory */}
                    {!_.isEmpty(formData.serviceType) && formData.serviceType.value && formData.serviceType.value !== 'event' && formData.device.value && formData.device.value !== 'KM6L' && formData.hookupType.value && formData.hookupType.value === 'home hookup' &&
                        <CustomTextField
                            label="Serial Number"
                            mandatory={false}
                            size={TEXT_FIELD_CONST.SIZE.SMALL}
                            variant={TEXT_FIELD_CONST.VARIANT.OUTLINED}
                            stateKey='deviceSerialNumber'
                            value={formData.deviceSerialNumber}
                            type='text'
                            // placeholder='Enter serial number'
                            onChange={handleFormDataUpdate}
                            maxlength={50}
                            validateForm={validateForm}
                        />
                    }
                    {/* when serviceType is not event(Holter) and device is not KM6L (Kardia patch) & hookupType is not home hookup show deviceSerialNumber with mandatory */}
                    {!_.isEmpty(formData.serviceType) && formData.serviceType.value && formData.serviceType.value !== 'event' && formData.device.value && formData.device.value !== 'KM6L' && formData.hookupType.value && formData.hookupType.value !== 'home hookup' &&
                        <CustomTextField
                            label="Serial Number"
                            mandatory={true}
                            size={TEXT_FIELD_CONST.SIZE.SMALL}
                            variant={TEXT_FIELD_CONST.VARIANT.OUTLINED}
                            stateKey='deviceSerialNumber'
                            value={formData.deviceSerialNumber}
                            type='text'
                            // placeholder='Enter serial number'
                            onChange={handleFormDataUpdate}
                            maxlength={50}
                            validateForm={validateForm}
                        />
                    }
                </Grid>
                <Grid item xs={12}>
                    <CustomMultiSelect
                        label="ICD-10 Diagnosis Codes"
                        placeholder='Select ICD-10 Diagnosis codes'
                        variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                        menuItems={ICD10_CODE}
                        valueKey='value'
                        labelKey='label'
                        labelKeys={['id', 'name']}
                        labelDisplaySeparator=' - '
                        // labelDisplayPrefix='Dr.'
                        // labelDisplaySeparator=' == '
                        stateKey='icd10Codes'
                        selectedValue={formData.icd10Codes}
                        handleChange={handleFormDataUpdate}
                        mandatory={true}
                        validateForm={validateForm}
                    />
                </Grid>
                
                {/* Study Purpose (Moved to R4)*/}
                {/* <Grid item xs={12}>
                    <CustomTextField
                        label="Study Purpose"
                        // placeholder='Enter Study Purpose'
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        rows={1}
                        maxlength={10000}
                        // value={formData.note}
                        // stateKey='note'
                        //onChange={handleFormDataUpdate}
                    />
                </Grid> */}
                {/* ============= End of Grid ============= */}
            </Grid>
        </div>
    );
}

export default StudyEnrollmentForm


// WEBPACK FOOTER //
// ./src/views/components/StudyEnrollmentForm/StudyEnrollmentForm.jsx